import { cn } from "@/lib/utils";

const SIZE_CLASSES = {
  sm: "h-6 w-6 border-2",
  md: "h-10 w-10 border-4",
  lg: "h-12 w-12 border-4",
} as const;

interface LoadingSpinnerProps {
  label?: string;
  description?: string;
  size?: keyof typeof SIZE_CLASSES;
  /** Altura do container. Ex.: "h-screen", "h-[80vh]", "h-64". Padrão: "h-full". */
  containerClassName?: string;
  className?: string;
}

export function LoadingSpinner({
  label,
  description,
  size = "md",
  containerClassName = "h-full",
  className,
}: LoadingSpinnerProps) {
  return (
    <div className={cn("flex items-center justify-center", containerClassName, className)}>
      <div className="flex flex-col items-center gap-3">
        <div
          className={cn(
            "animate-spin rounded-full border-primary border-t-transparent",
            SIZE_CLASSES[size]
          )}
        />
        {label && (
          <p className="text-sm font-medium text-foreground">{label}</p>
        )}
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
    </div>
  );
}

export default LoadingSpinner;
